import React, { useState } from "react";
import BGImg from "../Assests/Images/2022.jpg";
import { useNavigate } from "react-router-dom";
import { signIn } from "../../Services/authService";
import Swal from "sweetalert2";

export default function StaffLogin() {

    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        designation: "Receptionist",
        email: "",
        password: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [loginLoading, setLoginLoading] = useState(false);

    const roleIds = {
        Admin: 1,
        Doctor: 2,
        Receptionist: 3,
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const Toast = Swal.mixin({
        toast: true,
        position: "top",
        showConfirmButton: false,
        timer: 2500,
        timerProgressBar: true,
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        const typeId = roleIds[formData.designation];

        const payload = {
            Email: formData.email,
            Password: formData.password,
            RoleId: typeId,
        };

        try {
            setLoginLoading(true);

            const data = await signIn(payload);

            if (data?.status === 200 && data?.result === "success") {
                const user = data?.data?.user;

                sessionStorage.setItem("roleId", user?.RoleId || typeId);
                sessionStorage.setItem("designation", formData.designation);
                sessionStorage.setItem("email", user?.Email || formData.email);
                sessionStorage.setItem("userData", JSON.stringify(user));

                Toast.fire({
                    icon: "success",
                    title: data?.response || "Login successful",
                });

                if (user?.RoleId === 1) {
                    navigate("/receptionist/dashboard");
                } else if (user?.RoleId === 2) {
                    navigate("/doctor/dashboard");
                } else if (user?.RoleId === 3) {
                    navigate("/receptionist/dashboard");
                }
            } else {
                Toast.fire({
                    icon: "error",
                    title: data?.message || "Invalid username or password",
                });
            }
        } catch (error) {
            const errorData = error.response?.data;

            Toast.fire({
                icon: "error",
                title: errorData?.message || "Invalid username or password",
            });
        } finally {
            setLoginLoading(false);
        }
    };

    return (
        <div
            className="min-vh-100 d-flex align-items-center justify-content-center position-relative"
            style={{
                backgroundImage: `linear-gradient(rgba(7, 19, 38, 0.58), rgba(7, 19, 38, 0.72)), url(${BGImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="container px-4 py-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-sm-11 col-md-9 col-lg-8 col-xl-6">
                        <div
                            className="card border-0 rounded-4 overflow-hidden shadow-lg"
                            style={{
                                background: "rgba(255, 255, 255, 0.78)",
                                border: "1px solid rgba(255,255,255,0.28)",
                                boxShadow: "0 24px 60px rgba(15, 23, 42, 0.28)",
                            }}
                        >
                            <div
                                className="card-body p-4 p-md-5"
                                style={{
                                    background: "linear-gradient(135deg, rgba(255,255,255,0.38), rgba(255,255,255,0.18))",
                                }}
                            >
                                <div className="text-center mb-4">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle bg-white shadow-sm mb-3"
                                        style={{ width: "78px", height: "78px" }}
                                    >
                                        <i className="bi bi-hospital text-primary fs-1"></i>
                                    </div>

                                    <h2 className="fw-bolder text-dark mb-2">
                                        Staff Login
                                    </h2>

                                    <div className="text-muted fs-6">
                                        Secure access for doctors and reception staff
                                    </div>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="mb-4">
                                        <label className="form-label fw-semibold text-dark mb-3">
                                            Login As
                                        </label>

                                        <div className="row g-3">
                                            <div className="col-12 col-md-4">
                                                <label
                                                    className={`w-100 rounded-4 border d-flex align-items-center gap-3 px-3 py-3 ${formData.designation === "Receptionist"
                                                        ? "border-warning bg-warning bg-opacity-10 shadow-sm"
                                                        : "bg-white bg-opacity-75"
                                                        }`}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="designation"
                                                        value="Receptionist"
                                                        checked={formData.designation === "Receptionist"}
                                                        onChange={handleChange}
                                                        className="form-check-input m-0"
                                                    />

                                                    <span
                                                        className={`d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0 ${formData.designation === "Receptionist"
                                                            ? "bg-warning text-white"
                                                            : "bg-light-warning text-warning"
                                                            }`}
                                                        style={{ width: "44px", height: "44px" }}
                                                    >
                                                        <i className="bi bi-person-workspace fs-5"></i>
                                                    </span>

                                                    <span className="text-start">
                                                        <span className="d-block fw-bold text-dark">Receptionist</span>
                                                        <span className="d-block text-muted fs-8">Desk access</span>
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <label
                                                    className={`w-100 rounded-4 border d-flex align-items-center gap-3 px-3 py-3 ${formData.designation === "Doctor"
                                                        ? "border-primary bg-primary bg-opacity-10 shadow-sm"
                                                        : "bg-white bg-opacity-75"
                                                        }`}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="designation"
                                                        value="Doctor"
                                                        checked={formData.designation === "Doctor"}
                                                        onChange={handleChange}
                                                        className="form-check-input m-0"
                                                    />

                                                    <span
                                                        className={`d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0 ${formData.designation === "Doctor"
                                                            ? "bg-primary text-white"
                                                            : "bg-light-primary text-primary"
                                                            }`}
                                                        style={{ width: "44px", height: "44px" }}
                                                    >
                                                        <i className="bi bi-heart-pulse fs-5"></i>
                                                    </span>

                                                    <span className="text-start">
                                                        <span className="d-block fw-bold text-dark">Doctor</span>
                                                        <span className="d-block text-muted fs-8">Clinical access</span>
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <label
                                                    className={`w-100 rounded-4 border d-flex align-items-center gap-3 px-3 py-3 ${formData.designation === "Admin"
                                                        ? "border-danger bg-danger bg-opacity-10 shadow-sm"
                                                        : "bg-white bg-opacity-75"
                                                        }`}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <input
                                                        type="radio"
                                                        name="designation"
                                                        value="Admin"
                                                        checked={formData.designation === "Admin"}
                                                        onChange={handleChange}
                                                        className="form-check-input m-0"
                                                    />

                                                    <span
                                                        className={`d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0 ${formData.designation === "Admin"
                                                            ? "bg-danger text-white"
                                                            : "bg-light-danger text-danger"
                                                            }`}
                                                        style={{ width: "44px", height: "44px" }}
                                                    >
                                                        <i className="bi bi-shield-lock fs-5"></i>
                                                    </span>

                                                    <span className="text-start">
                                                        <span className="d-block fw-bold text-dark">Admin</span>
                                                        <span className="d-block text-muted fs-8">System access</span>
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-semibold text-dark">
                                            Email Address
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-white border-0 border-end">
                                                <i className="bi bi-envelope text-primary"></i>
                                            </span>
                                            <input
                                                type="email"
                                                name="email"
                                                className="form-control border-0 py-3"
                                                placeholder="Enter email address"
                                                value={formData.email}
                                                onChange={handleChange}
                                                style={{ backgroundColor: "rgba(255,255,255,0.92)" }}
                                            />
                                        </div>
                                    </div>

                                    <div className="mb-4">
                                        <label className="form-label fw-semibold text-dark">
                                            Password
                                        </label>
                                        <div className="input-group">
                                            <span className="input-group-text bg-white border-0 border-end">
                                                <i className="bi bi-lock text-primary"></i>
                                            </span>

                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                className="form-control border-0 py-3"
                                                placeholder="Enter password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                style={{ backgroundColor: "rgba(255,255,255,0.92)" }}
                                            />

                                            <button
                                                type="button"
                                                className="input-group-text bg-white border-0 border-start"
                                                onClick={() => setShowPassword((prev) => !prev)}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <i className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"} text-primary`}></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id="rememberMe" />
                                            <label className="form-check-label text-muted" htmlFor="rememberMe">
                                                Remember me
                                            </label>
                                        </div>

                                        <button
                                            type="button"
                                            className="btn btn-link text-primary p-0 text-decoration-none fw-semibold"
                                        >
                                            Forgot password?
                                        </button>
                                    </div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100 fw-bold rounded-3 py-3 shadow-sm"
                                        disabled={loginLoading}
                                    >
                                        {loginLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                Logging in...
                                            </>
                                        ) : (
                                            <>
                                                <i className="bi bi-box-arrow-in-right me-2"></i>
                                                Login to Dashboard
                                            </>
                                        )}
                                    </button>
                                </form>

                                <div className="text-center mt-4">
                                    <span className="badge badge-light-primary px-4 py-2 rounded-pill">
                                        <i className="bi bi-shield-lock me-2"></i>
                                        Authorized Medical Staff Only
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
